import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarSecondaryService, CclDrawerService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { SessionService } from "../../../../modules/shared/services/session-service";

@Component({
    selector: "app-data-page",
    templateUrl: "./data-page.view.html",
    styleUrls: []
})
export class DataPageView implements AfterViewInit, OnInit {
    catalogLayoutConfig: any = {};
    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        private drawerService: CclDrawerService,
        public sharedService: SharedService,
        private sessionService: SessionService
    ) {
        this.navSecondaryService.sectionLabel = "Data";
    }

    ngAfterViewInit(): void {}

    ngOnInit() {
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);

        if (
            this.sharedService.catalogLayoutConfig.vipUnit == "card" ||
            this.sharedService.catalogLayoutConfig.vipUnit == "list"
        ) {
            this.sharedService.catalogNavigateHelper("admin", "catalog/data/highlighted");
        } else {
            this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
        }

        this.navSecondaryService.sectionLabel = "Data";

        this.sessionService.getSpeakerTypes(this.sharedService.event.id).subscribe((data) => {
            if (data.body != null) {
                this.sharedService.speakerTypes = data.body["content"];
            }
        });
    }

    clickEdit(item) {
        this.drawerService.toggleDrawer("small");
        let url = "config-drawer/filter-config";
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
